import { useRef } from "react";
import CountUp from "react-countup";
import { useInView } from "framer-motion";
import { STATS } from "@/data/site";

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section data-testid="stats-section" ref={ref} className="relative overflow-hidden bg-[var(--green-deep)] py-20 md:py-28">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[var(--green)]/40 blur-3xl" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-2 gap-y-12 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <div key={s.label} data-testid={`stat-${i}`} className="text-center lg:border-l lg:border-white/15 lg:first:border-l-0">
              <div className="font-display text-5xl font-bold text-[var(--gold)] md:text-6xl">
                {inView ? <CountUp end={s.value} duration={2.4} separator="," /> : 0}
                <span>{s.suffix}</span>
              </div>
              <p className="mt-3 text-sm font-medium uppercase tracking-wider text-white/75">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
